import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=34099f7a"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.29.6_supports-color@8.1.1____6d4bc6e641adf69df12baf0f484d3174/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DTLoaderDots: require('/vercel/path0/node_modules/.pnpm/@docue+docue-ui@1.22.0_tsx@4.21.0_vue-final-modal@2.4.3_vue@2.7.16__vue@2.7.16/node_modules/@docue/docue-ui/src/components/DTLoaderDots/DTLoaderDots.vue').default})
